module.exports = __webpack_public_path__ + "static/media/email-line.8c26944e.svg";